export default __webpack_public_path__ + "static/Roboto-Medium-7c8d04cd831df3033c8a96a2668d645e.ttf";